import { TpvokComponent } from './components/tpvok/tpvok.component';
import { RecuperarPymeComponent } from './components/recuperar-pyme/recuperar-pyme.component';
import { RecuperarClienteComponent } from './components/recuperar-cliente/recuperar-cliente.component';
import { PreconsultaComponent } from './components/preconsulta/preconsulta.component';
import { PreservicioComponent } from './components/preservicio/preservicio.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { FiscalDocComponent } from './components/fiscal-doc/fiscal-doc.component';
import { LaboralDocComponent } from './components/laboral-doc/laboral-doc.component';
import { ContableDocComponent } from './components/contable-doc/contable-doc.component';
import { ContableComponent } from './components/contable/contable.component';
import { FiscalComponent } from './components/fiscal/fiscal.component';
import { LaboralComponent } from './components/laboral/laboral.component';
import { ClientePymeComponent } from './components/cliente-pyme/cliente-pyme.component';
import { ClientesPymesComponent } from './components/clientes-pymes/clientes-pymes.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { UsuarioComponent } from './components/usuario/usuario.component';
import { LoginAdminPymesComponent } from './components/login-admin-pymes/login-admin-pymes.component';
import { LoginAdminComponent } from './components/login-admin/login-admin.component';
import { ConsultasComponent } from './components/consultas/consultas.component';
import { ActuacionAdjuntoComponent } from './components/actuacion-adjunto/actuacion-adjunto.component';
import { ExpedienteActuacionComponent } from './components/expediente-actuacion/expediente-actuacion.component';
import { ExpedienteIntervinienteComponent } from './components/expediente-interviniente/expediente-interviniente.component';
import { AdjuntoComponent } from './components/adjunto/adjunto.component';
import { ExpedienteComponent } from './components/expediente/expediente.component';
import { ConsultaComponent } from './components/consulta/consulta.component';
import { DireccionComponent } from './components/direccion/direccion.component';
import { MiperfilComponent } from './components/miperfil/miperfil.component';
import { RoleGuardService } from './services/role-guard.service';
import { AuthGuardService } from './services/auth-guard.service';
import { ClienteComponent } from './components/cliente/cliente.component';
import { IntervinienteComponent } from './components/interviniente/interviniente.component';
import {RouterModule, Routes} from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { PerfilesComponent } from './components/perfiles/perfiles.component';
import { MensajesComponent } from './components/mensajes/mensajes.component';
import { IntervinientesComponent } from './components/intervinientes/intervinientes.component';
import { ExpendientesComponent } from './components/expendientes/expendientes.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { LoginComponent } from './components/login/login.component';
import { ProvisionComponent } from './components/provision/provision.component';
import { SuplidoComponent } from './components/suplido/suplido.component';
import { MensajeComponent } from './components/mensaje/mensaje.component';

const APP_ROUTES: Routes=[
    {path: 'login', component: LoginComponent},
    {path: 'loginAdmin', component: LoginAdminComponent},
    {path: 'loginAdminPymes', component: LoginAdminPymesComponent},
    {path: 'home', component: HomeComponent, canActivate:[AuthGuardService]},
    {path: 'miperfil', component:MiperfilComponent, canActivate: [AuthGuardService]},
    {path: 'direccion/:cod', component:DireccionComponent, canActivate: [AuthGuardService]},
    {path: 'consultas', component:ConsultaComponent, canActivate: [AuthGuardService]},
    {path: 'clientes', component: ClientesComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'clientesPymes', component: ClientesPymesComponent, canActivate:[AuthGuardService]},
    {path: 'clientePyme/:ref', component:ClientePymeComponent, canActivate:[AuthGuardService]},
    {path: 'expedientes', component: ExpendientesComponent, canActivate:[AuthGuardService]},
    {path: 'expediente/:cod', component: ExpedienteComponent, canActivate:[AuthGuardService]},
    {path: 'adjunto/:cod', component: AdjuntoComponent, canActivate:[AuthGuardService]},
    {path: 'expedienteInterviniente/:cod', component:ExpedienteIntervinienteComponent, canActivate:[AuthGuardService]},
    {path: 'expedienteActuacion/:cod', component:ExpedienteActuacionComponent, canActivate:[AuthGuardService]},
    {path: 'actuacionAdjunto/:cod', component:ActuacionAdjuntoComponent, canActivate:[AuthGuardService]},
    {path: 'provision/:cod', component:ProvisionComponent, canActivate:[AuthGuardService]},
    {path: 'suplido/:cod', component:SuplidoComponent, canActivate:[AuthGuardService]},
    {path: 'mensaje/:cod', component: MensajeComponent, canActivate:[AuthGuardService]},
    {path: 'consulta/:tipo', component: ConsultasComponent},
    {path: 'intervinientes', component: IntervinientesComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'usuarios', component: UsuariosComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'perfiles', component: PerfilesComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'mensajes', component: MensajesComponent, canActivate:[AuthGuardService]},
    {path: 'perfil/:cod', component: PerfilComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'interviniente/:cod', component: IntervinienteComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'usuario/:cod', component: UsuarioComponent, canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'cliente/:ref',component: ClienteComponent,canActivate:[AuthGuardService, RoleGuardService]},
    {path: 'laboral', component:LaboralComponent, canActivate:[AuthGuardService]},
    {path: 'laboralDoc/:cod', component:LaboralDocComponent, canActivate:[AuthGuardService]},
    {path: 'fiscal', component:FiscalComponent, canActivate:[AuthGuardService]},
    {path: 'fiscalDoc/:cod', component:FiscalDocComponent, canActivate:[AuthGuardService]},
    {path: 'contable', component:ContableComponent, canActivate:[AuthGuardService]},
    {path: 'contableDoc/:cod', component:ContableDocComponent, canActivate:[AuthGuardService]},
    {path: 'documentos', component:DocumentosComponent, canActivate:[AuthGuardService]},
    {path: 'preconsulta', component: PreconsultaComponent},
    {path: 'preservicio', component: PreservicioComponent},
    {path: 'recuperarCliente', component: RecuperarClienteComponent},
    {path: 'recuperarPyme', component: RecuperarPymeComponent},
    {path: 'tpvok', component: TpvokComponent},
    {path: '**', redirectTo:'home'}
];

export const APP_ROUTING=RouterModule.forRoot(APP_ROUTES , {useHash:true});


// WEBPACK FOOTER //
// ./src/app/app.routes.ts